export default "__VITE_ASSET__123616ca__"